import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractDomComponent} from "../../framework/abstract-dom";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-radio-dom",
    styleUrls: ["./radio-dom.component.scss"],
    templateUrl: "./radio-dom.component.html",
    standalone: false
})
export class FUIRadioDomComponent extends FUIAbstractDomComponent {
}
